import { Button, Tooltip } from 'antd';
import { UnorderedListOutlined, OrderedListOutlined } from '@ant-design/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var listsItems = function listsItems(labels) {
  return [{
    type: 'button',
    tooltip: labels.bulletList,
    icon: /*#__PURE__*/_jsx(UnorderedListOutlined, {}),
    onClick: function onClick(editor) {
      return editor.chain().focus().toggleBulletList().run();
    },
    isActive: function isActive(editor) {
      return editor.isActive('bulletList');
    }
  }, {
    type: 'button',
    tooltip: labels.orderedList,
    icon: /*#__PURE__*/_jsx(OrderedListOutlined, {}),
    onClick: function onClick(editor) {
      return editor.chain().focus().toggleOrderedList().run();
    },
    isActive: function isActive(editor) {
      return editor.isActive('orderedList');
    }
  }];
};

export var ListingMenu = function ListingMenu(_ref) {
  var editor = _ref.editor,
      labels = _ref.labels;
  var items = listsItems(labels);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: items.map(function (item, index) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: item.tooltip,
        children: /*#__PURE__*/_jsx(Button, {
          icon: item.icon,
          onClick: function onClick() {
            return item.onClick(editor);
          },
          type: item.isActive ? item.isActive(editor) ? 'primary' : 'text' : 'text'
        })
      }, index);
    })
  });
};